import { get_axios_instance, get_axios_file_instance, api_variables, errorHandler } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_FEED_GET);
var axios_instance_create = get_axios_file_instance(api_variables.SERVICE_FEED_CREATE);

//const _pk_name = "id";

const state = {
  data: {},
  exits: {},
  isFetching: false,
  isSaving: false,
  isDeleting: false
};

const mutations = {
  set: (state, payload) => {
    state.data = payload;
    //console.log('fetched data', state.data)
  },
  setExits: (state, payload) => {
    if (payload) {
      state.exits = payload;
    }
    //console.log('fetched exits', state.exits)
  },
  addEmployee: (state, payload) => {
    //console.log('payload data from store', payload)
    state.data = payload;
    //console.log('exit data', state.exits);
    //console.log('state data', state.data);
    // state.data.push(payload);
  },
  setFetching: (state, payload) => {
    state.isFetching = payload;
  },
  setSaving: (state, payload) => {
    state.isSaving = payload;
  },
  setDeleting: (state, payload) => {
    state.isDeleting = payload;
  },
}

const updateTokenForGet = () => {
  let token = localStorage.getItem('token') ? localStorage.getItem('token').replace(/(^"|"$)/g, '') : "";
  axios_instance.defaults.headers['Authorization'] = `Bearer ${token}`;
}

const actions = {
  async fetchAll({ commit }, payload) {
    //console.log("Announcement Working...", payload);
    try {
      updateTokenForGet();
      commit("setFetching", true);
      let res = await axios_instance.get(``, {
        params: {
          le_id: payload
        }
      });
      commit("setFetching", false);
      //console.log("Announcement res: ", res);
      if (res.status == 200) {
        //console.log('Fetch data', res);
        //commit("set", res.data.rows);
      }

      return res;
    } catch (error) {
      //console.log('error', error);
      throw errorHandler(error.response);
    }
  },

  async create({ commit }, payload) {
    //console.log("Announcement Adding...", payload);
    try {
      commit("setSaving", true);
      let res = await axios_instance_create.post('', payload);
      //console.log("Announcement Adding After...", payload);
      commit("setSaving", false);
      if (res.status == 200) {
        //console.log('Create data', res);
        //commit("addemployeedocument", payload);
      }
      return res;
      
    } catch (error) {
      //console.log('error', error.response);
      throw errorHandler(error.response);

    }
  },

}

export default {
  namespaced: true,
  state, mutations, actions
}